import { ApiRequestError } from "./api-error.js";

export type AuthState =
  | "checking"
  | "signed_in"
  | "signed_out"
  | "onboarding"
  | "provisioning"
  | "unavailable";

/** Maps API failures without confusing a missing account with a missing session. */
export const authStateForError = (error: unknown): AuthState => {
  if (!(error instanceof ApiRequestError)) {
    return "unavailable";
  }
  if (error.code === "no_account") {
    return "onboarding";
  }
  if (error.code === "tenant_provisioning") {
    return "provisioning";
  }
  if (error.status === 401 || error.code === "unauthenticated") {
    return "signed_out";
  }
  return "unavailable";
};
